import gsap from 'gsap'

import Component from 'gia/Component';
import eventbus from 'gia/eventbus';
import loadComponents from 'gia/loadComponents';
import getComponentFromElement from 'gia/getComponentFromElement';
import removeComponents from 'gia/removeComponents';



import barba from '@barba/core';

import config from 'gia/config';
import Loader from './loader';
import Blur from './blur';

import stage from '../components/stage'

import Projects from './projects';
import Project from './project';
import Grid from './grid';
import Overlay from './overlay';
import Makers from './makers';
import lazySizes from 'lazysizes';

class App {

  constructor($) {
    this.create()
  }

  create() {

    config.set('log', false);


      this.comps = {

        Blur: Blur,
        Projects: Projects,
        Project: Project,
        Overlay: Overlay,
        Grid: Grid,
        Makers: Makers
      }

      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);
      this.resize(stage)

      const components = {
        Loader: Loader
      }

      var loadercontainer = document.getElementById('loader')
      loadComponents(components, loadercontainer)

      this.body = $('body')

      eventbus.on('startBlur', this.startBlur.bind(this));

      $('.contact-link').on('click', (e)=>{
        e.preventDefault()
        var contact = $('.contact')
        var active = this.body.hasClass('has-contact')

        if(active){
          $('.contact-link').html('Contact')
        }
        else {
          $('.contact-link').html('Back')

        }
        this.body.removeClass('has-overview has-push')
        $('.push.is-opened').removeClass('is-opened')
        this.body.toggleClass('has-contact')


      })

      $('.menu__container a').not('.contact-link').on('click', (e)=>{
        $('.menu__container a').removeClass('active')
        $(e.currentTarget).addClass('active')
      })


      $('.overview__link').on('click', (e)=>{
        e.preventDefault()
        !this.body.hasClass('has-overview') && $(".overview")[0].scrollTo(0,0)
        this.body.toggleClass('has-overview')

      })




      var thiz = this
      barba.hooks.leave((data) => {
        this.removeModules(data)
      });
      barba.hooks.beforeEnter((data) => {
        this.resizeIntro(data)
      });
      barba.hooks.after((data) => {
        this.addModules(data)
        ga('set', 'page', window.location.pathname);
        ga('send', 'pageview');
      });

      // barba.hooks.after(() => {
      //   window.dataLayer.push({
      //     event: 'VirtualPageview',
      //     virtualPageURL: window.location.pathname + window.location.search,
      //     virtualPageTitle: document.title
      //   });
      // });
      gsap.set('.transition', {yPercent: 100, force3D: true})

      barba.init({
      transitions: [{
        name: 'projects',
        to: {
          namespace: [
            'projects'
          ]
        },
        leave(data) {
          const done = this.async();
          $('.transition').removeClass('has-logo')
          $('.push.is-opened').removeClass('is-opened')
          gsap.fromTo('.transition', {
            opacity: 1,
            yPercent:100,
          },{
            yPercent: 0,
            force3D: true,
            duration: 1
          });

          gsap.to(data.current.container, {
            opacity: 0,
            duration: .1,
            delay: 1,
            onComplete : () => { done() }

          });

        },
        enter(data) {
          const done = this.async();
          window.scrollTo(0,0)
          $('html').removeClass('blue')

          $('body').removeClass('has-canvas has-overview has-contact has-push from-projects').addClass('projects')
          gsap.to('.transition',{
            opacity: 0,
            duration: 1,
            delay: .1,
            onComplete : () => {
              done(); }
          });

          gsap.from(data.next.container, {
            opacity: 0,
            duration: .1,
          });
        }
      },
      {
        name: 'home',
        to: {
          namespace: [
            'home'
          ]
        },
        leave(data) {
          const done = this.async();
          $('.transition').addClass('has-logo')
          $('.push.is-opened').removeClass('is-opened')
          gsap.fromTo('.transition', {
            opacity: 0,
            yPercent: 0
          },{
            opacity: 1,
            yPercent: 0,
            force3D: true,
            ease: "power4.out",
            duration: .9
          });


          gsap.to(data.current.container, {
            opacity: 0,
            duration: .1,
            delay: 1.3,
            onComplete : () => { done();  }
          });

        },
        enter(data) {
          const done = this.async();
          window.scrollTo(0,0)
          $('body').removeClass('has-canvas has-overview has-push has-contact projects')
          $('body').addClass('from-projects')
          gsap.to('.transition',{
            yPercent: -100,
            duration: 2,
            ease: "power4.inOut",
            delay: .1,
            onComplete : () => { done(); }
          });

          gsap.fromTo('.intro', {yPercent: 100 , force3D:true, ease: "power4.inOut"}, {yPercent: 0 , force3D:true, ease: "power4.inOut", duration: 2, delay: .1})

          gsap.from(data.next.container, {
            opacity: 0,
            duration: .1
          });


        }
      }]
    });





  }

  startBlur(){
    var main = $('main')[0]
    loadComponents(this.comps, main)
  }


  resize(){


      var el = $('.intro')
      if(el.length > 0){
        gsap.set(el, {height: stage.h})
      }


  }

  resizeIntro(data){
    this.resize()
  }


  addModules(data){



    loadComponents(this.comps, data.next.container)


  }

  removeModules(data){

    removeComponents(data.current.container)
  }

}

module.exports = App
